import {
  JUDGE_ADVISOR_ID,
  JUDGE_ID,
  COACH_ID,
  EVENT_ADMIN_ID,
} from 'shared/constants/eventRoleTypes';

const ALL_ROLES = [JUDGE_ADVISOR_ID,
  EVENT_ADMIN_ID,
  JUDGE_ID,
  COACH_ID,]

export default [
  {
    //combined description label for same link
    description: ['reviewingQuestionsLabel', 'reviewingSheetLabel','awardsListLabel'],
    default: "https://firstinspires.blob.core.windows.net/fll/explore/2026-27/fll-explore-bioglow-reviewing-sheet.pdf",
    "es-MX": "",
    "tr": "",
    "nl": "",
    "he": "",
    roles: ALL_ROLES
  },
]